module.exports = __webpack_public_path__ + "img/newFiltersVisual.403ae667.png";